module.exports = __webpack_public_path__ + "static/media/1.9.253f2b0d.png";